/** Opens the Premium plans in checkout (upgrade or renew). The QR is the logged-in owner's own. */
export function navigateToPremiumPurchase(navigate, { qrId, variant = "upgrade" } = {}) {
  navigate("/order", {
    state: {
      qrId: qrId ? qrId.trim().toUpperCase() : undefined,
      autoValidate: Boolean(qrId),
      premiumFlow: variant,
    },
  });
}
